import React from 'react';
import { Layout, Typography } from 'antd';
import { Header } from 'antd/es/layout/layout';

const { Content } = Layout;
const { Title, Text } = Typography;

const MasterDataDashboardPage: React.FC = () => {
  return (
    <Layout className="min-h-screen bg-white">
      <Header className="bg-white px-6 sticky top-0 z-50 border-b border-gray-200">
        <Title level={3} className="m-0">
          Master Data Dashboard
        </Title>
      </Header>

      <Content className="px-6 py-8">
        <Text type="secondary">
          Dummy Dashboard for Master Data is configured successfully.
        </Text>
      </Content>
    </Layout>
  );
};

export default MasterDataDashboardPage;
